import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { auth } from '../../../../firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import { Text } from '../../../../core/design-system/components/Text';
import { Input } from '../../../../core/design-system/components/Input';
import { Button } from '../../../../core/design-system/components/Button';
import { Logo } from '../../../../core/design-system/components/Logo';
import './styles.css';

const PasswordReset = ({ onClose }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const { t } = useTranslation('auth');

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    if (!email) {
      setError(t('errors.required_field'));
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      onClose();
    } catch (error) {
      if (error.code === 'auth/user-not-found') {
        setError(t('errors.email_not_found'));
      } else {
        setError(t('errors.default'));
      }
    }
  };

  return (
    <div className="password-reset-content">
      <div className="password-reset-header">
        <Logo size={56} />
        <Text variant="h1" className="password-reset-title">
          {t('password_reset.title')}
        </Text>
      </div>

      <Text variant="body2" className="password-reset-description">
        {t('password_reset.description')}
      </Text>

      <form onSubmit={handlePasswordReset} className="password-reset-form">
        <div className="input-container">
          <Input
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError('');
            }}
            placeholder={t('login.email')}
            fullWidth
            error={error}
          />
          {error && <div className="field-error">{error}</div>}
        </div>

        <Button type="submit" variant="primary" size="lg" fullWidth>
          {t('password_reset.submit')}
        </Button>
      </form>

      <button className="text-link" onClick={onClose}>
        {t('password_reset.cancel')}
      </button>
    </div>
  );
};

export default PasswordReset; 